import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Breadcrumbs({ items }) {
  const location = useLocation();
  
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-gray-500 mb-4">
      <ol className="flex items-center gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <span className="text-gray-600">/</span>
              )}
              {isLast ? (
                <span className="text-gray-300 font-medium">{item.label}</span>
              ) : (
                <Link 
                  to={item.path} 
                  className="hover:text-gray-300 transition-colors"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
